import {
   CHANGE_VALUE_INPUTS_ENTERPRISE,
   GET_INFO_ENTERPRISE,
   CHANGE_URL_LOGO
} from '../constants/enterprise';

export const enterprise = ( state = {}, action ) => {
   switch ( action.type ) { 

      case CHANGE_VALUE_INPUTS_ENTERPRISE : {
         return action.payload;
      }

      case GET_INFO_ENTERPRISE : {
         return action.payload;
      }

      case CHANGE_URL_LOGO : {
         return action.payload;
      }
 
     default :
     return state;
   }
}